<template>
  <div class="createaccount--step">
    <vue-headful title="Create Account" />

    <v-layout wrap row>
      <v-flex xs12>
        <StepTitle>Account</StepTitle>
      </v-flex>
    </v-layout>

    <CreateAccountForm
      :apiError="apiError"
      :apiLookupError="apiErrorLookupUser"
      :hasExistingAccount="foundUser"
      :loadingCreateAccount="apiLoading"
      :loadingExistingAccount="apiLoadingLookupUser"
      @lookupUser="lookupUser"
      @resetUser="resetLookup"
      @submit="submitForm" />
  </div>
</template>

<script>
import { Constants } from '@homegauge/vue';

import CreateAccountForm from '@/components/forms/CreateAccountForm.vue';
import StepTitle from '@/components/StepTitle.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

const { AccountTypes } = Constants;

export default {
  components: {
    CreateAccountForm,
    StepTitle,
  },
  data() {
    return {
      apiError: null,
      apiErrorLookupUser: null,
      apiLoading: false,
      apiLoadingLookupUser: false,
      foundUser: false,
      userToken: '',
    };
  },
  methods: {
    async lookupUser(data) {
      return new Promise(async resolve => {
        let foundPerson = null;

        if (this.apiLoadingLookupUser) {
          resolve(foundPerson);
          return;
        }

        this.apiLoadingLookupUser = true;
        this.apiErrorLookupUser = null;
        try {
          foundPerson = await this.$store.dispatch('Person/lookupEmail', data);
          if (foundPerson) {
            this.foundUser = false;
            this.userToken = foundPerson.token;
          } else {
            this.foundUser = true;
          }
        } catch (err) {
          // silently fail
        }
        this.apiLoadingLookupUser = false;
        resolve(foundPerson);
      });
    },
    resetLookup() {
      this.apiLoadingLookupUser = false;
      this.foundUser = false;
      this.userToken = '';
    },
    async submitForm(data) {
      this.apiError = null;
      if (!data) {
        return;
      }

      const foundPerson = await this.lookupUser({
        email: data.email,
        type: data.type,
      });
      if (!foundPerson) {
        this.apiErrorLookupUser = {
          errors: [
            {
              field: 'email',
              message: `Email "${data.email}" is already in use`,
            },
          ],
        };
        return;
      }

      const user = {
        email: data.email,
        username: data.username,
        accountType: data.type,
        givenName: data.firstName,
        familyName: data.lastName,
        password: data.password,
        verifyPassword: data.passwordConfirm,
        phone: {
          number: data.phone,
          type: data.phoneType,
        },
        token: this.userToken,
      };

      if (data.type === AccountTypes.REAL_ESTATE_PROFESSIONAL) {
        user.companyName = data.company;
      }

      this.apiLoading = true;
      try {
        await this.$store.dispatch('Person/makeAccount', user);
        await this.$store.dispatch('Auth/loginUser', {
          username: user.username,
          password: user.password,
        });
        await this.$store.dispatch('Auth/getPerson');
        StepUtilities.goToNextStep(this.$route, this.$router);
      } catch (error) {
        this.apiError = error;
      }
      this.apiLoading = false;
    },
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentCreateAccount));
  },
};
</script>
